import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

export const InputLabelProps = {
  label: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export const InputLabel = ({ label, id }) => (
  <Label htmlFor={id}>{label}</Label>
);

InputLabel.propTypes = {
  ...InputLabelProps,
};

const Label = styled.label`
  font-size: 0.875rem;
  line-height: 1.29;
  color: ${(props) => props.theme.textColor};
  display: block;
  margin-bottom: 0.5rem;
`;
